var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"src":_vm.imageFailed ? _vm.defaultLogoURL : _vm.logoURL,"alt":"金电保","width":_vm.width,"height":_vm.height,"decoding":"async"},on:{"error":function($event){_vm.imageFailed = true}}})
}
var staticRenderFns = []

export { render, staticRenderFns }